module.exports = __webpack_public_path__ + "img/IMG_20200719_132350.9f769142.jpg";